module.exports = __webpack_public_path__ + "static/media/arrow-right.1a8d6c0d.svg";